import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { ListItem, ListItemComponent } from '../list-item/list-item.component';
import { AngularModule } from '../../../../modules/angular.module';

@Component({
	selector: 'app-list',
	standalone: true,
	imports: [ListItemComponent, AngularModule],
	templateUrl: './list.component.html',
	styleUrl: './list.component.scss',
})
export class ListComponent {
	@Input('enableSelect') public enableSelect: boolean = false;
	@Input('enableUpDown') public enableUpDown: boolean = false;
	@Input('enableCopy') public enableCopy: boolean = false;
	@Input('enableEdit') public enableEdit: boolean = false;
	@Input('enableDelete') public enableDelete: boolean = false;
	@Input('enablePreview') public enablePreview: boolean = false;
	@Input('itemUuidName') public itemUuidName: string | undefined;
	@Input('enableClickAsEdit') public enableClickAsEdit: boolean = false;
	@Input('isLeaf') public isLeaf: boolean = false;
	@Input('prefix') public prefix: string | undefined;
	@Input('selectedUuid') public selectedUuid: string | undefined;
	@Output('onSelect') onSelectEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onCopy') onCopyEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onEdit') onEditEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onDelete') onDeleteEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onMoveUp') onMoveUpEmitter: EventEmitter<any> = new EventEmitter<any>();
	@Output('onMoveDown') onMoveDownEmitter: EventEmitter<any> = new EventEmitter<any>();
	@ContentChild(TemplateRef) template!: TemplateRef<any>;

	private _items: ListItem[] = [];
	private _inProgressUuids: string[] = [];

	@Input('items')
	set items(value: any[]) {
		this._items = [...value].sort((a, b) => {
			// First, compare by display_order
			const displayOrderComparison = a.display_order - b.display_order;

			// If display_order is the same, then compare by name
			if (displayOrderComparison !== 0) {
				return displayOrderComparison;
			} else {
				// Safely access name, falling back to either active_text.name or name
				const nameA = a.active_text?.name || a.name || '';
				const nameB = b.active_text?.name || b.name || '';
				return nameA.localeCompare(nameB);
			}
		});
	}

	@Input('inProgressUuids')
	set inProgressUuids(value: string[]) {
		this._inProgressUuids = value;
	}

	get items(): any[] {
		return this._items;
	}

	get inProgressUuids(): string[] {
		return this._inProgressUuids;
	}

	public isInProgress(item: any): boolean {
		return this.inProgressUuids.includes(item.uuid);
	}

	public select(item: any): void {
		this.onSelectEmitter.emit(item);
	}

	public copy(item: any): void {
		this.onCopyEmitter.emit(item);
	}

	public edit(item: any): void {
		this.onEditEmitter.emit(item);
	}

	public delete(item: any): void {
		this.onDeleteEmitter.emit(item);
	}

	public moveUp(item: any): void {
		this.onMoveUpEmitter.emit(item);
	}

	public moveDown(item: any): void {
		this.onMoveDownEmitter.emit(item);
	}
}
